package com.karyadina.freesource.viewmodel

import androidx.lifecycle.ViewModel
import com.karyadina.freesource.model.FreeSource
import com.karyadina.freesource.repository.FreeSourceRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update

data class FreeSourceUiState(
    val sources: List<FreeSource> = emptyList(),
    val categories: List<String> = emptyList(),
    val searchQuery: String = "",
    val selectedCategory: String? = null
)

class FreeSourceViewModel(
    private val repository: FreeSourceRepository
) : ViewModel() {

    private val _uiState = MutableStateFlow(FreeSourceUiState())
    val uiState: StateFlow<FreeSourceUiState> = _uiState.asStateFlow()

    init {
        loadData()
    }

    private fun loadData() {
        _uiState.update { state ->
            state.copy(
                sources = repository.allSources,
                categories = repository.getCategories()
            )
        }
    }

    fun onSearchQueryChange(query: String) {
        _uiState.update { it.copy(searchQuery = query) }
        applyFilters()
    }

    fun onCategorySelected(category: String?) {
        _uiState.update { it.copy(selectedCategory = category) }
        applyFilters()
    }

    fun searchAndFilterWithLocale(isHindi: Boolean) {
        val currentState = _uiState.value
        val filteredList = repository.searchAndFilter(
            query = currentState.searchQuery,
            categoryEn = currentState.selectedCategory,
            isHindi = isHindi
        )
        _uiState.update { it.copy(sources = filteredList) }
    }

    private fun applyFilters(isHindi: Boolean = false) {
        val currentState = _uiState.value
        val filteredList = repository.searchAndFilter(
            query = currentState.searchQuery,
            categoryEn = currentState.selectedCategory,
            isHindi = isHindi
        )
        _uiState.update { it.copy(sources = filteredList) }
    }
}
